import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Syntax Highlighting"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "syntax-highlighting"
    }}>{`Syntax Highlighting`}</h1>
    <p>{`Add syntax highlighting to code fences in MDX.`}</p>
    <p>{`Install the Theme UI Prism component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i @theme-ui/prism
`}</code></pre>
    <p>{`If you're using Gatsby and `}<inlineCode parentName="p">{`gatsby-plugin-theme-ui`}</inlineCode>{`,
add the component to `}<inlineCode parentName="p">{`src/gatsby-plugin-theme-ui/components.js`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import Prism from '@theme-ui/prism'

const components = {
  pre: (props) => props.children,
  code: Prism,
}

export default components
`}</code></pre>
    <p>{`Import and add a syntax theme from the Prism component to your theme object.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// src/gatsby-plugin-theme-ui/index.js
import nightOwl from '@theme-ui/prism/presets/night-owl'

const theme = {
  styles: {
    pre: {
      ...nightOwl,
    },
  },
}

export default theme
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      